export default [
  {
    path: '/chat-suporte',
    name: 'app-chat-suporte',
    component: () => import('@/views/apps/chat-suporte/ChatList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Chat de Suporte',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Chat de Suporte',
          active: true,
        },
      ],
    },
  },
  {
    path: '/chat-suporte/:id',
    name: 'app-chat-suporte-detail',
    component: () => import('@/views/apps/chat-suporte/ChatDetail.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Chat de Suporte',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Chat de Suporte',
          active: false,
          to: {
            name: 'app-chat-suporte',
          },
        },
        {
          text: 'Detalhes',
          active: true,
        },
      ],
    },
  },
]
